import * as React from 'react';

import { useSelector } from 'react-redux';

import { selectGamesByCategory, selectGamesLoading } from '@/store/games/selectors';
import CategoryPageContent from '@/pages/games/categories/CategoryPageContent';
import { useIntl } from 'react-intl';
import { BffGamesCategory } from '@lucky7ventures/bff-types';

function CategoryPage({
  category,
  subheader,
}: {
  category: BffGamesCategory;
  subheader?: boolean;
}): JSX.Element {
  const intl = useIntl();

  const games = useSelector(selectGamesByCategory(category));
  const gamesLoading = useSelector(selectGamesLoading);

  const subheaderContent = subheader
    ? intl.formatMessage({ id: `games.categories.${category}.info` })
    : undefined;

  return (
    <CategoryPageContent
      header={intl.formatMessage({ id: `games.categories.${category}` })}
      subheader={subheaderContent}
      category={category}
      games={games}
      loading={gamesLoading}
    />
  );
}

export default CategoryPage;
